export default __webpack_public_path__ + "static/media/lighthouse.cfea0296.png";